import { PROYECT, api_get, api_post, api_put, api_delete } from "services/api";

import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";

import { addLabelArray } from "helpers/addLabelArray";
import { CAPTURES_TYPES } from "redux/reducers/buildings/captures/capturesTypes";
import { CAPTURES_PHRASE } from "views/buildings/Captures/config";

const {
  SET_CAPTURES,
  SET_SELECTED_ROUTE_CYCLE,
  NEW_CAPTURE,
  SET_ROUTE_CYCLES,
  EDIT_CAPTURE,
  SET_EDITED_CAPTURE,
  CLEAR_CAPTURES,
  SET_CANCEL_MOTIVES,
  SET_SELECTED_MOTIVE,
  HANDLE_CAPTURES_INPUTS
} = CAPTURES_TYPES;

const getUrlCaptures = routeCycleID =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/route_cycles/${routeCycleID}/captures`;
const getUrlRouteCycles = stationID =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/route_cycles/open_cycles?stations=${stationID}`;
const closeUrlRouteCycles = routeCycleID =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/route_cycles/${routeCycleID}/close_cycle`;
const syncUrlRouteCycles = routeCycleID =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/route_cycles/${routeCycleID}/sync_cycle`;
const getUrlCancelMotives = () =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/cancellations/motives`;

export function newCapture() {
  return {
    type: NEW_CAPTURE
  };
}
export function clearCaptures() {
  return {
    type: CLEAR_CAPTURES
  };
}

export function selectRouteCycle(routeCycle) {
  return {
    type: SET_SELECTED_ROUTE_CYCLE,
    payload: routeCycle
  };
}

export function selectCancellationMotive(motive) {
  return {
    type: SET_SELECTED_MOTIVE,
    payload: motive
  };
}

export function editCapture(id) {
  return {
    type: EDIT_CAPTURE,
    payload: id
  };
}

export const handleCapturesInputsAction = (key, value) => async dispatch => {
  try {
    if (key === "station" && value?.id) {
      await dispatch(fetchRouteCycles(value?.id));
    }
    else if (key === "station" && !value?.id) {
      dispatch({ type: SET_ROUTE_CYCLES,  payload: { routeCycles: [] } });
      dispatch( selectRouteCycle(null) );
    }
    dispatch({ type: HANDLE_CAPTURES_INPUTS, payload: { key, value } });
  } catch (error) {
    dispatch({ type: HANDLE_CAPTURES_INPUTS, payload: { key, value: null } });
    dispatch(setSnackbar(error));
  }
};

export const fetchRouteCycles = (idStation = null) => async dispatch => {
  dispatch(startRequestComp("fetchRouteCycles"));
  try {
    const routeCycles = await api_get(getUrlRouteCycles(idStation));
    const newNewRouteCycles = addLabelArray(routeCycles, "name");

    dispatch({
      type: SET_ROUTE_CYCLES,
      payload: {
        routeCycles: newNewRouteCycles
      }
    });

    dispatch(stopRequestComp("fetchRouteCycles"));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchRouteCycles"));
  }
};

export const fetchCaptures = (routeCycleID = null) => async dispatch => {
  dispatch(startRequestComp("fetchCaptures"));

  try {
    const captures = await api_get(getUrlCaptures(routeCycleID));

    dispatch({
      type: SET_CAPTURES,
      payload: {
        captures
      }
    });

    dispatch(stopRequestComp("fetchCaptures"));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchCaptures"));
  }
};

export const fetchCloseCycle = (
  routeCycleID = null,
  onSuccess = () => { }
) => async dispatch => {
  dispatch(startRequestComp("fetchCloseCycle"));

  try {
    const captures = await api_post(closeUrlRouteCycles(routeCycleID));

    dispatch({
      type: SET_CAPTURES,
      payload: {
        captures
      }
    });

    dispatch(
      setSnackbar(CAPTURES_PHRASE.search.messages.closeCapture, "success")
    );

    if (onSuccess) {
      onSuccess();
    }

    dispatch(stopRequestComp("fetchCloseCycle"));
  } catch (error) {
    dispatch(setSnackbar(error));
    if (onSuccess) {
      onSuccess();
    }
    dispatch(stopRequestComp("fetchCloseCycle"));
  }
};

export const fetchSyncCycle = (routeCycleID = null) => async dispatch => {
  dispatch(startRequestComp("fetchSyncCycle"));

  try {
    const captures = await api_post(syncUrlRouteCycles(routeCycleID));

    dispatch({
      type: SET_CAPTURES,
      payload: {
        captures
      }
    });

    dispatch(stopRequestComp("fetchSyncCycle"));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchSyncCycle"));
  }
};

export const fetchEditCapture = (body, id, routeCycleID) => async dispatch => {
  dispatch(startRequestComp("fetchEditCapture"));

  const urlCaptures = getUrlCaptures(routeCycleID);
  try {
    const response = await api_put(`${urlCaptures}/${id}`, body);

    const editedCapture = Array.isArray(response) ? response[0] : response;

    dispatch({
      type: SET_EDITED_CAPTURE,
      payload: editedCapture
    });

    dispatch(stopRequestComp("fetchEditCapture"));
  } catch (error) {
    console.error(error);
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchEditCapture"));
  }
};

export const fetchCancelMotives = () => async dispatch => {
  dispatch(startRequestComp("fetchCancelMotives"));
  try {
    const response = await api_get(getUrlCancelMotives());
    const cancelMotives = response;

    dispatch({
      type: SET_CANCEL_MOTIVES,
      payload: cancelMotives
    });
  } catch (error) {
    console.error(error);
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("fetchCancelMotives"));
  }
}

export const fetchCancelCapture = (
  idRouteCycle,
  idCapture,
  idMotive,
  callback
) => async dispatch => {
  dispatch(startRequestComp("fetchCancelCapture"));

  const urlCaptures = `${getUrlCaptures(idRouteCycle)}`;
  try {
    const response = await api_delete(`${urlCaptures}/${idCapture}?idMotive=${idMotive}`);
    const editedCapture = response;

    dispatch({
      type: SET_EDITED_CAPTURE,
      payload: editedCapture
    });

    dispatch(setSnackbar(CAPTURES_PHRASE.search.messages.cancelCapture, "success"));
    if (callback) {
      return callback()
    }
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("fetchCancelCapture"));
  }
};
